document.addEventListener("DOMContentLoaded", function () {
  const fullDescription = document.querySelector(".full-description");
  const shortDescription = document.querySelector(".short-description");
  const readMoreBtn = document.querySelector(".read-more-btn");

  if (!fullDescription || !shortDescription || !readMoreBtn) return;

  readMoreBtn.addEventListener("click", function () {
    if (fullDescription.classList.contains("hidden")) {
      fullDescription.classList.remove("hidden");
      shortDescription.style.display = "none";
      readMoreBtn.textContent = "Read Less";
    } else {
      fullDescription.classList.add("hidden");
      shortDescription.style.display = "block";
      readMoreBtn.textContent = "Read More";
    }
  });
});
